export const SET_AUTHENTICATION = '[mutations] set authentication';
export const IS_USER_AUTHENTICATED = '[getters] is user authenticated';
export const SET_USERNAME = '[mutations] set username';
export const GET_USERNAME = '[getters] get username';
